import { test } from 'ramda';
import { createValidation } from '@validarium/core';

const regex = /^[\p{L}][\p{L} -]*[\p{L}]$/gu;
const id = 'validarium.invalidName';

const validateName = createValidation((name) => test(regex, name), { id });

export default validateName;
